import React, { useCallback, useEffect } from 'react';
import { Dropdown, DropdownProps, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "semantic-ui-react";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { getScheduleGames, getDartsEventManagerHeader, selectTournament, selectGroup } from "./DartsEventManager.slice";
import styles from "./DartsEventManager.module.scss"
import DartsEventManagerActiveButtons from "../../../components/Buttons/DartsEventManagerButtons/DartsEventManagerActiveButtons";
import DartsEventManagerInformButtons from "../../../components/Buttons/DartsEventManagerButtons/DartsEventManagerInformButtons";
import { mapIdNameToSelectOptions } from "../../../helpers/map.helper";
import { dateUtcToLocalShort } from "../../../helpers/date.helper";
import { DartsGameStatus } from "../../../common/types/DartsGameStatuses";
import { DartsGameType } from "../../../common/types/DartsGameTypes";

const DartsEventManager = () => {//DartsEventManager
    const dispatch = useAppDispatch()
    const { tournaments, groups, tournamentSelected, groupSelected, isLoading, scheduleGames } = useAppSelector(state => state.DartsEventManager);
    const permissions = useAppSelector(state => state.Auth.permissions);

    useEffect(() => {
        dispatch(getDartsEventManagerHeader());
        const query = `?TournamentIDs=${tournamentSelected}&GroupIDs=${groupSelected}`
        dispatch(getScheduleGames(query));
    }, []);

    const handleChangeActiveTournaments = (dropDownData: DropdownProps) => {
        dispatch(selectTournament(Number(dropDownData.value)));
        const query = `?TournamentIDs=${dropDownData.value}&GroupIDs=${groupSelected}`
        dispatch(getScheduleGames(query));
    };

    const handleChangeGroup = (dropDownData: DropdownProps) => {
        dispatch(selectGroup(Number(dropDownData.value)));
        const query = `?TournamentIDs=${tournamentSelected}&GroupIDs=${dropDownData.value}`
        dispatch(getScheduleGames(query));
    }

    const tournamentsOptions = useCallback(() => {
        return tournaments !== undefined ? mapIdNameToSelectOptions(tournaments) : [];
    }, [tournaments]);

    const groupsOptions = useCallback(() => {
        return groups !== undefined ? mapIdNameToSelectOptions(groups) : [];
    }, [groups]);

    return (
        <div className={styles.schedulePage}>
            {/*<Breadcrumbs />*/}
            <div className={styles.scheduleMatch}>
                {isLoading &&
                    <div style={{ textAlign: "center" }}>Loading...</div>
                }
                {!isLoading &&
                    <div className="schedule-match-inner">
                        <div className="schedule__tournaments-inner">
                            <div className="schedule__input-inner">
                                <div className={styles.label}>Tournament:</div>
                                <Dropdown fluid selection value={tournamentSelected}
                                    options={tournamentsOptions()} onChange={(_, data) => {handleChangeActiveTournaments(data);}}
                                />
                            </div>
                            <div className="schedule__input-inner">
                                <div className={styles.label}>Group:</div>
                                <Dropdown fluid selection value={groupSelected}
                                    options={groupsOptions()} onChange={(_, data) => {handleChangeGroup(data)}}
                                />
                            </div>
                        </div>
                        <div className={styles.informBlock}>
                            <DartsEventManagerInformButtons selectedGroup={groupSelected} selectedTournament={tournamentSelected}/>
                        </div>
                    </div>
                }
                <Table celled>
                    <TableHeader>
                        <TableRow>
                            {permissions['id'] &&
                                <TableHeaderCell>Id</TableHeaderCell>
                            }
                            <TableHeaderCell>Name</TableHeaderCell>
                            <TableHeaderCell>Date</TableHeaderCell>
                            <TableHeaderCell>Status</TableHeaderCell>
                            <TableHeaderCell>Type</TableHeaderCell>
                            <TableHeaderCell></TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {scheduleGames?.map(game => {
                            return (
                                <TableRow key={game.id}>
                                    {permissions['id'] &&
                                        <TableCell>{game.id}</TableCell>
                                    }
                                    <TableCell>{game.name}</TableCell>
                                    <TableCell>{dateUtcToLocalShort(game.date)}</TableCell>
                                    <TableCell>{DartsGameStatus[game.status]}</TableCell>
                                    <TableCell>{DartsGameType[game.type]}</TableCell>
                                    <TableCell>
                                        <div className={styles.actionsWrapper}>
                                            <DartsEventManagerActiveButtons gameId={game.id} gameType={game.type}/>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                {!scheduleGames.length && tournamentSelected && <div className={styles.nogGames}>No Games</div>}
            Breadcrumbs</div>
        </div>
    );
};

export default DartsEventManager;
